module.exports = __webpack_public_path__ + "media/images/games/memory_game/meemo/fronts/m4-047349e830008c13f489483fe8737f9a.png";